module.exports = __webpack_public_path__ + "images/homepage-hia-logo.png";


//////////////////
// WEBPACK FOOTER
// ./homepage/images/homepage-hia-logo.png
// module id = 860
// module chunks = 0